<template>
    <div>
        <b-modal
            id="add-product-popup"
            ref="modal"
            :title="titleHeading"
            size="sm"
            :ok-title="buttonText"
            no-close-on-backdrop
            hide-footer
            modal-class="hide-footer"
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                class="modal-form-format"
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Product Code"
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                v-model="formData.code"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 10,
                                }"
                                type="text"
                                placeholder="Enter product code"
                                name="code"
                                :class="{
                                    'is-invalid': errors.has('code'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-2"
                            label="Product Title"
                            label-for="input-2"
                        >
                            <b-form-input
                                id="input-2"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    min: 2,
                                    max: 50,
                                }"
                                type="text"
                                placeholder="Enter product title"
                                autocomplete="no"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Rating"
                            label-for="select-1"
                        >
                            <b-form-select
                                id="select-1"
                                v-model="formData.rating"
                                v-validate="{
                                    required: true,
                                }"
                                class="form-control"
                                :options="rating"
                                name="rating"
                                :class="{
                                    'is-invalid': errors.has('rating'),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titleHeading() {
            return this.selectedItem
                ? 'Modify Product Factor'
                : 'Add Product Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        }, // End of buttonLabel() method
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            rating: [
                { value: null, text: 'Select Rating' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                code: '',
                title: '',
                rating: null,
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
